// extracted by mini-css-extract-plugin
export default {"wrapperConditionPrakerja":"style_wrapperConditionPrakerja__mHq0-","wrapperText":"style_wrapperText__HLsi0"};